'use strict';var _desc,_value,_class;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const ex=require('pulsar-utils/dist-es6/ex');
const BaseControllerBackedDirective=require('../../../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const HandleUncaughtErrors=require('../../../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations.HandleUncaughtErrors;
const SocketResponse=require('../../../../../../dist-es6/client/dtos/socketResponse');
const BaseController=require('../../../../../../dist-es6/client/angularCommon/baseController');let

GroupsNotificationSettingsSubviewDirective=function(_BaseControllerBacked){_inherits(GroupsNotificationSettingsSubviewDirective,_BaseControllerBacked);function GroupsNotificationSettingsSubviewDirective(){_classCallCheck(this,GroupsNotificationSettingsSubviewDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(GroupsNotificationSettingsSubviewDirective,[{key:'objectBindings',get:function()
{
return[
'emailAddress'];

}},{key:'templateUrl',get:function()

{
return'/templates/features/notificationSettings/components/groupsNotificationSettingsSubviewDirective/groupsNotificationSettingsSubviewTemplate';
}},{key:'controller',get:function()

{
return GroupsNotificationSettingsSubviewDirectiveController;
}}]);return GroupsNotificationSettingsSubviewDirective}(BaseControllerBackedDirective);let


GroupsNotificationSettingsSubviewDirectiveController=(_class=function(_BaseController){_inherits(GroupsNotificationSettingsSubviewDirectiveController,_BaseController);_createClass(GroupsNotificationSettingsSubviewDirectiveController,null,[{key:'$inject',get:function()
{
return[
'$timeout',
'$modal',
'uncaughtErrorHandler',
'socketService',
'notificationService',
'groupsCommandAndQueryService',
'organizationDefaultsService',
'Analytics',
'uiCommandFactory'];

}}]);

function GroupsNotificationSettingsSubviewDirectiveController($timeout,
$modal,
uncaughtErrorHandler,
socketService,
notificationService,
groupsCommandAndQueryService,
organizationDefaultsService,
Analytics,
uiCommandFactory){_classCallCheck(this,GroupsNotificationSettingsSubviewDirectiveController);var _this2=_possibleConstructorReturn(this,
_BaseController.call(this,uncaughtErrorHandler));

_this2._$timeout=$timeout;
_this2._$modal=$modal;
_this2._socketService=socketService;
_this2._groupsCommandAndQueryService=groupsCommandAndQueryService;
_this2._organizationDefaultsService=organizationDefaultsService;
_this2._notificationService=notificationService;
_this2._analytics=Analytics;
_this2._uiCommandFactory=uiCommandFactory;

_this2._reloadSettings=_this2._reloadSettings.bind(_this2);

_this2._controllerInitialized=!1;

_this2.groups=[];

_this2._reloadSettings();return _this2;
}GroupsNotificationSettingsSubviewDirectiveController.prototype.


_reloadSettings=function(){var ref=_asyncToGenerator(function*(){
let notificationSettingsResponse=yield this._socketService.sendAndWaitForResponse('GetNotificationSettings');
if(!SocketResponse.succeeded(notificationSettingsResponse)){
this._notificationService.displayNotification('Failed to retrieve notification settings.','error');
return;
}

yield this._makeViewModelsFromLatestSettings(notificationSettingsResponse.body);
});function _reloadSettings(){return ref.apply(this,arguments)}return _reloadSettings}();GroupsNotificationSettingsSubviewDirectiveController.prototype.


_onNotificationsEnabledForGroupChanging=function(){var ref=_asyncToGenerator(function*(groupId,newIsChecked){
let messageName=newIsChecked?'EnableGroupNotifications':'DisableGroupNotifications';
let socketResponse=yield this._socketService.sendAndWaitForResponse(messageName,groupId);

yield this._handleErrorsReloadSettingsAndTrackForAnalytics(socketResponse,{
category:'ChangeUserSetting',
action:messageName,
label:`id=${groupId}`});

});function _onNotificationsEnabledForGroupChanging(groupId,newIsChecked){return ref.apply(this,arguments)}return _onNotificationsEnabledForGroupChanging}();GroupsNotificationSettingsSubviewDirectiveController.prototype.


_onNotificationTypeForGroupChanging=function(){var ref=_asyncToGenerator(function*(groupId,groupNotificationType){
let requestBody={groupId:groupId,groupNotificationType:groupNotificationType};
let socketResponse=yield this._socketService.sendAndWaitForResponse('SetGroupNotificationType',requestBody);

yield this._handleErrorsReloadSettingsAndTrackForAnalytics(socketResponse,{
category:'ChangeUserSetting',
action:'SetGroupNotificationType',
label:`type=${groupNotificationType.name}|id=${groupId}`});


});function _onNotificationTypeForGroupChanging(groupId,groupNotificationType){return ref.apply(this,arguments)}return _onNotificationTypeForGroupChanging}();GroupsNotificationSettingsSubviewDirectiveController.prototype.

_handleErrorsReloadSettingsAndTrackForAnalytics=function(){var ref=_asyncToGenerator(function*(socketResponse,analyticsEventInfo){
if(!SocketResponse.succeeded(socketResponse)){
if(socketResponse.status==='NotificationSettingsUpdateFailed'){
this._notificationService.displayNotification('Unable to update notification settings at this time. Please try again.','warning');
}else{
this._notificationService.displayNotification('An unexpected occurred updating notification settings. Please try again','error');
}
yield this._reloadSettings();
return;
}

yield this._makeViewModelsFromLatestSettings(socketResponse.body);

this._analytics.trackEvent(analyticsEventInfo.category,analyticsEventInfo.action,analyticsEventInfo.label);
});function _handleErrorsReloadSettingsAndTrackForAnalytics(socketResponse,analyticsEventInfo){return ref.apply(this,arguments)}return _handleErrorsReloadSettingsAndTrackForAnalytics}();GroupsNotificationSettingsSubviewDirectiveController.prototype.

_disposeCommands=function _disposeCommands(){
if(_.exists(this.groups)&&this.groups.length>0){
this.groups.forEach(function(group){
group.notificationsEnabledChangedCommand.dispose();
group.notificationTypeChangedCommand.dispose();
});
}
};GroupsNotificationSettingsSubviewDirectiveController.prototype.

_setThresholdFor=function _setThresholdFor(group,defaultThresholds){var _this3=this;
let modalInstance=this._$modal.open({
templateUrl:'/templates/features/groups/modals/setThresholdModalView',
controller:'SetThresholdModalController as controller',
resolve:{
resolvedParameters:function(){
return{
defaultFatigueThreshold:defaultThresholds.fatigueThreshold,
defaultDeviationThreshold:defaultThresholds.deviationThreshold,
group:group,
onThresholdSet:_this3._reloadSettings};

}}});



return modalInstance;
};GroupsNotificationSettingsSubviewDirectiveController.prototype.

_makeViewModelsFromLatestSettings=function(){var ref=_asyncToGenerator(function*(notificationSettings){var _this4=this;
let defaultThresholds=yield this._organizationDefaultsService.getOrganizationThresholds();
let groupsWithThresholds=yield this._groupsCommandAndQueryService.getFlattenedGroups();
let groupsWithThresholdsById=_.keyBy(groupsWithThresholds,'id');
let groupsGroupedByParentId=_.groupBy(groupsWithThresholds,'parentId');

let oldGroupsById=_.keyBy(this.groups,'id');
for(let group of notificationSettings.groupsSettings){
let existingGroup=oldGroupsById[group.id];
if(_.exists(existingGroup)){
group.notificationsEnabledChangedCommand=existingGroup.notificationsEnabledChangedCommand;
group.notificationTypeChangedCommand=existingGroup.notificationTypeChangedCommand;
}else{
group.notificationsEnabledChangedCommand=this._uiCommandFactory.make(function(newIsChecked){return _this4._onNotificationsEnabledForGroupChanging(group.id,newIsChecked)});
group.notificationTypeChangedCommand=this._uiCommandFactory.make(function(newType){return _this4._onNotificationTypeForGroupChanging(group.id,newType)});
}

group.fatigueThreshold=ex(_.get(groupsWithThresholdsById,`${group.id}.fatigueThreshold`)).
otherwise(defaultThresholds.fatigueThreshold);

group.deviationThreshold=ex(_.get(groupsWithThresholdsById,`${group.id}.deviationThreshold`)).
otherwise(defaultThresholds.deviationThreshold);

group.setThreshold=function(){return _this4._setThresholdFor(group,defaultThresholds)};

group.displayInList=groupsWithThresholdsById[group.id].personIds.length>0||!_.exists(groupsGroupedByParentId[group.id]);

const parentGroupNames=_getParentGroupNames(groupsWithThresholdsById[group.id],groupsWithThresholdsById);
group.fullDisplayName=_.concat(parentGroupNames,groupsWithThresholdsById[group.id].name).join(' > ');
}

this._$timeout(function(){
_this4.groups=_.sortBy(notificationSettings.groupsSettings,['fullDisplayName']);
_this4._controllerInitialized=!0;
});
});function _makeViewModelsFromLatestSettings(notificationSettings){return ref.apply(this,arguments)}return _makeViewModelsFromLatestSettings}();return GroupsNotificationSettingsSubviewDirectiveController}(BaseController),(_applyDecoratedDescriptor(_class.prototype,'_reloadSettings',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'_reloadSettings'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'_onNotificationsEnabledForGroupChanging',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'_onNotificationsEnabledForGroupChanging'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'_onNotificationTypeForGroupChanging',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'_onNotificationTypeForGroupChanging'),_class.prototype)),_class);


function _getParentGroupNames(group,groupsById){
const parents=[];

let lastChild=group;
while(lastChild=groupsById[lastChild.parentId]){
parents.push(lastChild);
}

return parents.map(function(p){return p.name}).reverse();

}

module.exports=GroupsNotificationSettingsSubviewDirective;
module.exports.controller=GroupsNotificationSettingsSubviewDirectiveController;
//# sourceMappingURL=groupsNotificationSettingsSubviewDirective.js.map
